import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5d7d3f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " Select the tools you use most in your research. ", -1))
const _hoisted_2 = { class: "editor-container" }

import { ref } from 'vue'
import Modal from '@/util/Modal.vue'
import ResearchToolsEditor from './ResearchToolsEditor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchToolsModal',
  props: {
    modelValue: {}
  },
  emits: [
  'update:modelValue'
],
  setup(__props: any, { emit }) {

const props = __props;





const modalRef = ref<InstanceType<typeof Modal>>()

function doneEditing() {
  modalRef.value?.close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    info: "",
    onOk: doneEditing
  }, {
    title: _withCtx(() => [
      _createTextVNode("Research tools")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Done")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ResearchToolsEditor, {
          "model-value": props.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = v => emit('update:modelValue', v))
        }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})